import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import {
    NavigationLinkDirective,
    ShFacetListComponent,
    ShFacetSummaryComponent,
    ShIconModule,
    ShNotificationComponent,
    ShPageHeaderComponent,
    ShPaginationComponent,
    ShTaskFacetListContainerComponent
} from '@stylehaven/components';

import { NgLetModule } from 'ng-let';
import { DigihavenElementsModule } from '../elements/elements.module';
import { LuceneHelper } from '../helpers/lucene.helper';
import { ReadableDatePipeModule } from '../pipes/readable-date-pipe';
import { RecordHeaderSandboxService } from '../record-header/sandbox/record-header-sandbox.service';
import { GetFieldPipe } from '../record/pipes/get-field.pipe';
import { GetShortRecordIdPipe } from '../record/pipes/get-short-record-id.pipe';
import { TranslateFieldDefinitionPipe } from '../record/pipes/translate-field-definition.pipe';
import { RecordModule } from '../record/record.module';
import { ColumnHandlerService } from '../record/services/column-handler.service';
import { RecordResolverService } from '../record/services/resolver/record-resolver.service';
import { SavedQueriesService } from '../services/saved-queries/saved-queries.service';
import { TaskDeadlineCellComponent } from './components/cells/task-deadline-cell/task-deadline-cell.component';
import { TaskTypeCellComponent } from './components/cells/task-type-cell/task-type-cell.component';
import { TaskContainerFactoryComponent } from './components/task-container-factory/task-container-factory.component';
import { TaskDashboardComponent } from './components/task-dashboard/task-dashboard.component';
import { TaskDetailComponent } from './components/task-detail-component/task-detail.component';
import { UnknownTaskComponent } from './components/unknown-task/unknown-task.component';
import { TaskOverviewContainerComponent } from './containers/task-overview-container/task-overview-container.component';
import { TasksSandboxService } from './sandbox/task.sandbox';
import { TaskColumnHandlerService } from './services/task-column-handler.service';
import { TaskContainerFactoryComponentService } from './services/task-container-factory.service';
import { TaskService } from './services/task.service';

@NgModule({
    declarations: [
        TaskDashboardComponent,
        TaskOverviewContainerComponent,
        TaskDetailComponent,
        TaskContainerFactoryComponent,
        UnknownTaskComponent,
        TaskTypeCellComponent,
        TaskDeadlineCellComponent
    ],
    imports: [
        CommonModule,
        ShIconModule,
        ShPageHeaderComponent,
        RouterModule,
        RecordModule,
        TranslateModule,
        DigihavenElementsModule,
        ReadableDatePipeModule,
        ShFacetSummaryComponent,
        ShFacetListComponent,
        ShNotificationComponent,
        NavigationLinkDirective,
        NgLetModule,
        ShTaskFacetListContainerComponent,
        ShPaginationComponent
    ],
    exports: [
        TaskDashboardComponent,
        TaskOverviewContainerComponent,
        TaskDetailComponent,
        TaskTypeCellComponent,
        TaskDeadlineCellComponent
    ],
    providers: [
        TasksSandboxService,
        TaskService,
        LuceneHelper,
        GetFieldPipe,
        GetShortRecordIdPipe,
        TranslateFieldDefinitionPipe,
        {
            provide: ColumnHandlerService,
            useClass: TaskColumnHandlerService
        },
        TaskContainerFactoryComponentService,
        SavedQueriesService,
        RecordResolverService,
        RecordHeaderSandboxService
    ]
})
export class TaskModule {}
export { TaskContainer } from './containers/task-container/task-container.component';
export * from './entities';
export { TaskColumnHandlerService } from './services/task-column-handler.service';
export { TaskDtoCellComponent } from './components/cells/task-dto-cell.component';
export { TaskDeadlineCellComponent } from './components/cells/task-deadline-cell/task-deadline-cell.component';
export { TaskTypeCellComponent } from './components/cells/task-type-cell/task-type-cell.component';
export { TaskContainerFactoryComponentService } from './services/task-container-factory.service';
export { TaskService } from './services/task.service';
export { MapToTaskSearch } from './helpers/map-to-task-search.helper';
export { DigihavenTaskFacetDataService } from './services/task-facet.data-service';
export { DigihavenTaskAutocompleteDataService } from './services/task-autocomplete.data-service';
